module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/assets/languages/ja.json
// module id = eud2
// module chunks = 1